import React from 'react';

import { whatsAppContactUs, whatsAppContactUsUrl } from '.';

export const ordersMTOAlertPE = (
  <div>
    El precio de los productos es referencial y no incluye descuentos, pudiendo
    existir diferencias en la boleta o factura.
    <br />
    En caso de que no puedas descargar tu comprobante de pago, contáctanos a
    través de WhatsApp al{' '}
    <strong>
      <a href={whatsAppContactUsUrl} target="_blank" rel="noreferrer">
        {whatsAppContactUs}
      </a>
    </strong>{' '}
    para poder ayudarte.
  </div>
);

export const ticketListMessages = {
  title: 'Mis solicitudes de atención',
  subtitle:
    'Aquí podrás encontrar todas las solicitudes de atención que has realizado.',
  error: 'Por ahora el servicio de consulta de solicitudes no está disponible',
};

export const ordersListMessages = {
  title: 'Mis compras realizadas',
  subtitle: 'Aquí podrás encontrar los estados de todas tus compras.',
  error: 'Por ahora no podemos mostrar tus compras',
};

export const authorizeThirdErrorMapper = new Map();
authorizeThirdErrorMapper.set(
  'CONTACT_04',
  'Lo sentimos, en este momento no podemos atender tu solicitud. Intenta nuevamente más tarde.',
);
authorizeThirdErrorMapper.set(
  'CONTACT_06',
  'Lo sentimos tu producto ya se encuentra en proceso de preparación, no es posible realizar el cambio.',
);
authorizeThirdErrorMapper.set(
  'CONTACT_07',
  'Lo sentimos tu compra esta realizada a través de la modalidad despacho a domicilio por lo que no es posible realizar el cambio solicitado, recuerda que tienes 5 días para retirarlo.',
);
authorizeThirdErrorMapper.set(
  'CONTACT_08',
  'Lo sentimos tu compra esta realizada a través de la modalidad despacho a domicilio por lo que no es posible realizar el cambio solicitado, recuerda que tienes 5 días para retirarlo.',
);
authorizeThirdErrorMapper.set(
  'UNKNOWN',
  'Lo sentimos tu compra no puede recibir modificaciones.',
);

export const changeDispatchAddressErrorMsg = (code) => {
  switch (code) {
    case 'CONTACT_04':
      return 'Lo sentimos, en este momento no podemos atender tu solicitud. Intenta nuevamente más tarde.';
    case 'CONTACT_06':
      return 'Lo sentimos, tu producto ya se encuentra en proceso de despacho, por lo que no es posible realizar el cambio de dirección.';
    case 'CONTACT_07':
      return 'Lo sentimos, tu compra fue realizada con la modalidad de retiro en tienda, por lo que no es posible hacer el cambio de dirección. Recuerda que tienes 5 días hábiles para retirar tu compra.';
    default:
      return 'Lo sentimos, no es posible realizar un cambio de dirección para el producto seleccionado.';
  }
};

export const changeProductErrorMsg = (code) => {
  switch (code) {
    case 'CONTACT_11':
      return 'Ya se cumplió el plazo de cambio de tu producto. Infórmanos aquí si tuviste algún problema.';
    case 'CONTACT_12':
      return 'Para cambiar este producto deberás hacerlo en una de nuestras tiendas. Debido a la contingencia, recuerda verificar que la tienda se encuentre abierta. Si es así, tendrás 90 días para realizar el cambio.';
    case 'CONTACT_13':
      return 'Este producto no tiene opción de cambio. Si tienes dudas, revisa nuestras políticas de cambio y devolución.';
    default:
      return 'Lo sentimos, no es posible realizar un cambio para el producto seleccionado.';
  }
};

export const messageGoldSilverAlert = (
  <div>
    <b>Recuerda:</b>
    <ul>
      <li>
        Los <b>clientes Silver</b> tienes 2 despachos gratis al mes y $4.000 de
        descuento en Despacho Go.
      </li>
      <li>
        Los <b>clientes Gold</b> tienes 3 despachos gratis al mes y $4.000 de
        descuento en Despacho Go.
      </li>
    </ul>
    Revisa las condiciones en nuestro Centro de Ayuda.
  </div>
);

export const messageNotGoldSilverAlert = (
  <div>
    Lo sentimos, no podemos realizar esta acción ya que no apareces en nuestros
    registros de clientes Gold o Silver.
  </div>
);

export const messageCancellationStatusAlert = (
  <div>
    <p>
      Si compraste con <b>Tarjeta Ripley</b>, la reversa se realizará en un
      plazo de <b>7 a 10 días hábiles</b> contados desde el día siguiente a tu
      solicitud de nota de crédito.
    </p>
    <p>
      Si compraste con <b>Tarjeta de Crédito o Débito</b>, la reversa estará
      disponible entre <b>10 a 15 días hábiles</b> a partir del día siguiente a
      tu nota de crédito.
    </p>
  </div>
);
